import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=f4fce2b4&scoped=true&"
import script from "./Poster.vue?vue&type=script&lang=js&"
export * from "./Poster.vue?vue&type=script&lang=js&"
import style0 from "./Poster.vue?vue&type=style&index=0&id=f4fce2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fce2b4",
  null
  
)

export default component.exports